// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../Fuel/font/digital-7.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*media breaks*/
@font-face {
  font-family: "digital-clock-font";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.orderContent {
  display: flex;
  flex-direction: column;
  color: #4d4d4d;
  width: 100%;
  min-height: 72vh;
}
.orderContent .head {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  width: 80%;
  margin: 0 auto;
}
.orderContent .head h4 {
  padding: 1%;
  margin: 0.5vh auto;
  text-align: center;
  color: #4d4d4d;
  border-radius: 5px;
  background-color: #fff;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  width: 310px;
}
.orderContent .boxes {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  min-height: 75vh;
}
.orderContent .boxes input {
  margin: 2% auto;
}
.orderContent .quantities {
  display: flex;
  justify-content: space-evenly;
  padding: 1%;
  width: 40%;
  margin: auto;
  margin-bottom: 1%;
  align-items: center;
}
.orderContent .quantities .qty {
  width: 48%;
  text-align: center;
  background-color: #fff;
  font-weight: bold;
  display: flex;
  justify-content: space-evenly;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  border-radius: 1rem;
}
.orderContent .quantities .qty input {
  border: none;
  background-color: #fff;
  width: 80%;
  color: #4d4d4d;
}
.orderContent .row {
  display: flex;
  justify-content: space-evenly;
  width: 50%;
  margin: auto;
}
.orderContent .row p {
  text-align: center;
  padding: 5%;
  border: 1px solid #c2c2c2;
  border-radius: 50%;
  background: #fff;
}
.orderContent #invoice,
.orderContent .additional-items-table {
  table-layout: fixed;
  background-color: #fff;
  border-collapse: collapse;
  color: #4d4d4d;
  width: 80%;
  margin: auto;
}
.orderContent #invoice thead,
.orderContent .additional-items-table thead {
  border-bottom: 1px solid #4d4d4d;
  text-align: center;
}
.orderContent #invoice tbody,
.orderContent .additional-items-table tbody {
  text-align: center;
}
.orderContent #invoice tbody tr,
.orderContent .additional-items-table tbody tr {
  border-bottom: 1px solid #4d4d4d;
}
.orderContent #invoice tbody tr:nth-child(odd),
.orderContent .additional-items-table tbody tr:nth-child(odd) {
  background-color: #f2f2f2;
}
.orderContent #invoice tbody tr input,
.orderContent .additional-items-table tbody tr input {
  width: 20%;
  margin: 0 auto;
  text-align: center;
}
.orderContent .additional-items-table {
  margin: 2vh auto;
}
.orderContent #section {
  width: 75%;
  margin: auto;
  margin-top: 0;
  background-color: #fff;
  border-collapse: collapse;
}
.orderContent #section th {
  background-color: #64c4e0;
}
.orderContent #section td {
  border-bottom: 1px solid #4d4d4d;
}
.orderContent #section td:nth-child(2) {
  text-align: center;
}
.orderContent #section td:nth-child(3) {
  text-align: center;
}
.orderContent #section td:nth-child(3) input {
  text-align: center;
  width: 30%;
  border: 1px solid #4d4d4d;
  border-radius: 0.3rem;
  height: 2rem;
}
.orderContent .staffName,
.orderContent .note_section {
  margin: 1.5vh auto;
  width: 40%;
  min-width: 310px;
  border-radius: 5px;
  height: 4.5vh;
  font-size: 1.1rem;
}
.orderContent .note_section {
  height: 12vh;
  padding-top: 5px;
  max-width: 40%;
  max-height: 12vh;
}
.orderContent .final_submit_btn {
  width: 40%;
  min-width: 310px;
  margin: 1.5vh auto;
}
.orderContent .checkInput {
  width: 30%;
  border: none;
  border-radius: 0.3rem;
  height: 2rem;
}
.orderContent .pack {
  font-size: 1.4rem;
}
.orderContent .loadingSection {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.orderContent input[type=file] {
  align-self: center;
}
.orderContent .image__div img {
  align-self: center;
  margin-left: 30%;
}
.orderContent textarea {
  width: 30%;
  align-self: center;
  margin: 1% auto;
}

@media (max-width: 600px) {
  .orderContent .quantities {
    width: 80%;
    min-height: 12vh;
  }
  .orderContent .quantities .qty {
    font-size: 0.9rem;
  }
  .orderContent .row {
    width: 80%;
  }
  .orderContent #invoice,
  .orderContent .additional-items-table {
    display: block;
  }
  .orderContent #invoice .table_header,
  .orderContent .additional-items-table .table_header {
    display: none;
  }
  .orderContent #invoice thead,
  .orderContent .additional-items-table thead {
    height: 0;
    display: block;
  }
  .orderContent #invoice thead tr,
  .orderContent .additional-items-table thead tr {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }
  .orderContent #invoice thead tr th,
  .orderContent .additional-items-table thead tr th {
    display: block;
  }
  .orderContent #invoice tbody,
  .orderContent .additional-items-table tbody {
    display: block;
  }
  .orderContent #invoice tbody tr,
  .orderContent .additional-items-table tbody tr {
    display: block;
    margin-bottom: 0.5vh;
    border: 1px solid #ccc;
  }
  .orderContent #invoice tbody tr td,
  .orderContent .additional-items-table tbody tr td {
    display: block;
    border: none;
    border-bottom: 1px solid #eee;
    position: relative;
    padding-left: 50%;
  }
  .orderContent #invoice tbody tr td:before,
  .orderContent .additional-items-table tbody tr td:before {
    position: absolute;
    top: 2px;
    left: 6px;
    width: 45%;
    padding-right: 10px;
    white-space: nowrap;
    font-weight: 700;
    text-align: left;
  }
  .orderContent #invoice td:nth-of-type(1):before,
  .orderContent .additional-items-table td:nth-of-type(1):before {
    content: "Product";
  }
  .orderContent #invoice td:nth-of-type(2):before,
  .orderContent .additional-items-table td:nth-of-type(2):before {
    content: "Ordered";
  }
  .orderContent #invoice td:nth-of-type(3):before,
  .orderContent .additional-items-table td:nth-of-type(3):before {
    content: "Received";
  }
  .orderContent #invoice td:nth-of-type(4):before,
  .orderContent .additional-items-table td:nth-of-type(4):before {
    content: "Current Stock";
  }
  .orderContent #invoice,
  .orderContent .additional-items-table,
  .orderContent #section {
    width: 80%;
  }
  .orderContent #invoice td:nth-child(3) input,
  .orderContent .additional-items-table td:nth-child(3) input,
  .orderContent #section td:nth-child(3) input {
    text-align: center;
    width: 50%;
    border: 1px solid #4d4d4d;
    border-radius: 0.3rem;
    height: 2rem;
  }
  .orderContent .pack {
    font-size: 1.1rem;
  }
  .orderContent .image__div img {
    width: 60%;
    margin-left: 20%;
  }
  .orderContent textarea {
    width: 50%;
  }
}
@media (min-width: 601px) and (max-width: 900px) {
  .orderContent .image__div img {
    width: 60%;
    margin-left: 20%;
  }
}
.discrepancy_modal {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}
.discrepancy_modal .discrepancy_table {
  table-layout: fixed;
  background-color: #fff;
  border-collapse: collapse;
  color: #4d4d4d;
  width: 90%;
  margin: 0 auto;
}
.discrepancy_modal .discrepancy_table thead {
  border-bottom: 1px solid #4d4d4d;
  text-align: center;
}
.discrepancy_modal .discrepancy_table tbody {
  text-align: center;
}
.discrepancy_modal .discrepancy_table tbody tr {
  border-bottom: 1px solid #4d4d4d;
}
.discrepancy_modal .discrepancy_table tbody tr:nth-child(odd) {
  background-color: #f2f2f2;
}
.discrepancy_modal .discrepancy_table tbody tr input {
  width: 20%;
  margin: 0 auto;
  text-align: center;
}
.discrepancy_modal .discrep_modal_row {
  width: 90%;
  margin: 2% auto;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  flex-wrap: wrap;
}

.add-extra-items-modal {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 600px;
  height: 60vh;
  max-height: 50vh;
  background-color: #fff;
  border: 2px solid #000;
  box-shadow: 24;
  padding: 10px;
  overflow-y: auto;
  position: relative;
  overflow-y: auto;
}
@media (max-width: 600px) {
  .add-extra-items-modal {
    width: 95vw;
  }
}
.add-extra-items-modal h1 {
  margin: 0;
  font-size: 1.5rem;
  box-shadow: 0 4px 2px -2px rgb(124, 124, 124);
}
.add-extra-items-modal .search-items {
  margin: 0.5vh auto;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 1vw;
}
.add-extra-items-modal .search-items input {
  width: 70%;
  height: 4.2vh;
  border-radius: 5px;
}
.add-extra-items-modal .search-items button {
  width: 10%;
}
.add-extra-items-modal .alert-section {
  height: 7vh;
}
.add-extra-items-modal .product-tables {
  min-height: 22vh;
}
.add-extra-items-modal .product-tables .additional-items-table-container,
.add-extra-items-modal .product-tables .multiple-items-table-container {
  margin: 0.5vh auto;
}
.add-extra-items-modal .product-tables .additional-items-table-container p,
.add-extra-items-modal .product-tables .multiple-items-table-container p {
  text-align: center;
  color: #000;
  font-weight: 500;
  font-size: 1.2rem;
}
.add-extra-items-modal .product-tables .additional-items-table-container .additional-items-table,
.add-extra-items-modal .product-tables .multiple-items-table-container .additional-items-table {
  background-color: rgb(160, 255, 160);
}
.add-extra-items-modal .product-tables .additional-items-table-container .additional-items-table,
.add-extra-items-modal .product-tables .additional-items-table-container .multiple-items-table,
.add-extra-items-modal .product-tables .multiple-items-table-container .additional-items-table,
.add-extra-items-modal .product-tables .multiple-items-table-container .multiple-items-table {
  width: 100%;
  font-size: 0.9em;
  font-family: sans-serif;
  table-layout: fixed;
}
.add-extra-items-modal .product-tables .additional-items-table-container .additional-items-table thead,
.add-extra-items-modal .product-tables .additional-items-table-container .multiple-items-table thead,
.add-extra-items-modal .product-tables .multiple-items-table-container .additional-items-table thead,
.add-extra-items-modal .product-tables .multiple-items-table-container .multiple-items-table thead {
  height: 4vh;
}
.add-extra-items-modal .product-tables .additional-items-table-container .additional-items-table thead tr,
.add-extra-items-modal .product-tables .additional-items-table-container .multiple-items-table thead tr,
.add-extra-items-modal .product-tables .multiple-items-table-container .additional-items-table thead tr,
.add-extra-items-modal .product-tables .multiple-items-table-container .multiple-items-table thead tr {
  background-color: #2c53a0;
  color: #ffffff;
  text-align: left;
}
.add-extra-items-modal .product-tables .additional-items-table-container .additional-items-table thead tr th,
.add-extra-items-modal .product-tables .additional-items-table-container .multiple-items-table thead tr th,
.add-extra-items-modal .product-tables .multiple-items-table-container .additional-items-table thead tr th,
.add-extra-items-modal .product-tables .multiple-items-table-container .multiple-items-table thead tr th {
  text-align: center;
}
.add-extra-items-modal .product-tables .additional-items-table-container .additional-items-table tbody tr,
.add-extra-items-modal .product-tables .additional-items-table-container .multiple-items-table tbody tr,
.add-extra-items-modal .product-tables .multiple-items-table-container .additional-items-table tbody tr,
.add-extra-items-modal .product-tables .multiple-items-table-container .multiple-items-table tbody tr {
  border-bottom: 1px solid #dddddd;
}
.add-extra-items-modal .product-tables .additional-items-table-container .additional-items-table tbody tr:first-of-type,
.add-extra-items-modal .product-tables .additional-items-table-container .multiple-items-table tbody tr:first-of-type,
.add-extra-items-modal .product-tables .multiple-items-table-container .additional-items-table tbody tr:first-of-type,
.add-extra-items-modal .product-tables .multiple-items-table-container .multiple-items-table tbody tr:first-of-type {
  border-top: 2px solid #2c53a0;
}
.add-extra-items-modal .product-tables .additional-items-table-container .additional-items-table tbody tr:last-of-type,
.add-extra-items-modal .product-tables .additional-items-table-container .multiple-items-table tbody tr:last-of-type,
.add-extra-items-modal .product-tables .multiple-items-table-container .additional-items-table tbody tr:last-of-type,
.add-extra-items-modal .product-tables .multiple-items-table-container .multiple-items-table tbody tr:last-of-type {
  border-bottom: 2px solid #2c53a0;
}
.add-extra-items-modal .product-tables .additional-items-table-container .additional-items-table tbody tr td,
.add-extra-items-modal .product-tables .additional-items-table-container .multiple-items-table tbody tr td,
.add-extra-items-modal .product-tables .multiple-items-table-container .additional-items-table tbody tr td,
.add-extra-items-modal .product-tables .multiple-items-table-container .multiple-items-table tbody tr td {
  text-align: center;
  padding: 12px 15px;
  word-wrap: break-word;
  color: black;
  font-size: 1rem;
  font-weight: 500;
}
.add-extra-items-modal .btn-section {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 1vw;
  margin: 2vh;
  background-color: #fff;
  z-index: 9000;
}
.add-extra-items-modal .btn-section button {
  width: 45%;
}`, "",{"version":3,"sources":["webpack://./src/components/variables.scss","webpack://./src/components/StoreZone/styles/Orders.scss"],"names":[],"mappings":"AAOA,eAAA;AAeA;EACI,iCAAA;EACA,4CAAA;ACpBJ;AAFA;EACI,aAAA;EACA,sBAAA;EACA,cDFQ;ECGR,WAAA;EACA,gBAAA;AAIJ;AAHI;EACI,aAAA;EACA,6BAAA;EACA,eAAA;EACA,UAAA;EACA,cAAA;AAKR;AAJQ;EACI,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,cDfA;ECgBA,kBAAA;EACA,sBAAA;EACA,2CAAA;EACA,YAAA;AAMZ;AAHI;ED2CA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;EC5CI,gBAAA;AAQR;AAPQ;EACI,eAAA;AASZ;AANI;EACI,aAAA;EACA,6BAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;AAQR;AAPQ;EACI,UAAA;EACA,kBAAA;EACA,sBAAA;EACA,iBAAA;EACA,aAAA;EACA,6BAAA;EACA,2CAAA;EACA,mBAAA;AASZ;AARY;EACI,YAAA;EACA,sBAAA;EACA,UAAA;EACA,cAAA;AAUhB;AANI;EACI,aAAA;EACA,6BAAA;EACA,UAAA;EACA,YAAA;AAQR;AAPQ;EACI,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AASZ;AANI;;EDiEA,mBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAvIQ;ECsEJ,UAAA;EACA,YAAA;AAWR;ADsDI;;EACI,gCAAA;EACA,kBAAA;ACnDR;ADqDI;;EACI,kBAAA;AClDR;ADmDQ;;EACI,gCAAA;AChDZ;ADiDY;;EACI,yBAAA;AC9ChB;ADgDY;;EACI,UAAA;EACA,cAAA;EACA,kBAAA;AC7ChB;AAhCI;EACI,gBAAA;AAkCR;AAhCI;EACI,UAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;AAkCR;AAjCQ;EACI,yBDrFC;ACwHb;AAjCQ;EACI,gCAAA;AAmCZ;AAjCQ;EACI,kBAAA;AAmCZ;AAjCQ;EACI,kBAAA;AAmCZ;AAlCY;EACI,kBAAA;EACA,UAAA;EACA,yBAAA;EACA,qBAAA;EACA,YAAA;AAoChB;AAhCI;;EAEI,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,iBAAA;AAkCR;AA/BI;EACI,YAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAiCR;AA/BI;EACI,UAAA;EACA,gBAAA;EACA,kBAAA;AAiCR;AA9BI;EACI,UAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;AAgCR;AA9BI;EACI,iBAAA;AAgCR;AA9BI;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAgCR;AA9BI;EACI,kBAAA;AAgCR;AA7BQ;EACI,kBAAA;EACA,gBAAA;AA+BZ;AA5BI;EACI,UAAA;EACA,kBAAA;EACA,eAAA;AA8BR;;AA1BA;EAEQ;IACI,UAAA;IACA,gBAAA;EA4BV;EA3BU;IACI,iBAAA;EA6Bd;EA1BM;IACI,UAAA;EA4BV;EAzBM;;IAEI,cAAA;EA2BV;EA1BU;;IACI,aAAA;EA6Bd;EA1BU;;IACI,SAAA;IACA,cAAA;EA6Bd;EA5Bc;;IACI,kBAAA;IACA,YAAA;IACA,aAAA;EA+BlB;EA9BkB;;IACI,cAAA;EAiCtB;EA5BU;;IACI,cAAA;EA+Bd;EA9Bc;;IACI,cAAA;IACA,oBAAA;IACA,sBAAA;EAiClB;EAhCkB;;IACI,cAAA;IACA,YAAA;IACA,6BAAA;IACA,kBAAA;IACA,iBAAA;EAmCtB;EAhCkB;;IACI,kBAAA;IACA,QAAA;IACA,SAAA;IACA,UAAA;IACA,mBAAA;IACA,mBAAA;IACA,gBAAA;IACA,gBAAA;EAmCtB;EA/BU;;IACI,kBAAA;EAkCd;EAhCU;;IACI,kBAAA;EAmCd;EAjCU;;IACI,mBAAA;EAoCd;EAlCU;;IACI,wBAAA;EAqCd;EAjCM;;;IAGI,UAAA;EAmCV;EAjCc;;;IACI,kBAAA;IACA,UAAA;IACA,yBAAA;IACA,qBAAA;IACA,YAAA;EAqClB;EAhCM;IACI,iBAAA;EAkCV;EA/BU;IACI,UAAA;IACA,gBAAA;EAiCd;EA9BM;IACI,UAAA;EAgCV;AACF;AA7BA;EAGY;IACI,UAAA;IACA,gBAAA;EA6Bd;AACF;AAxBA;ED3MI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;ACsOJ;AA5BI;ED1IA,mBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAvIQ;ECgRJ,UAAA;EACA,cAAA;AAiCR;AD1KI;EACI,gCAAA;EACA,kBAAA;AC4KR;AD1KI;EACI,kBAAA;AC4KR;AD3KQ;EACI,gCAAA;AC6KZ;AD5KY;EACI,yBAAA;AC8KhB;AD5KY;EACI,UAAA;EACA,cAAA;EACA,kBAAA;AC8KhB;AAjDI;EACI,UAAA;EACA,eAAA;EDhMJ,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,eAAA;ACoPJ;;AAlDA;ED3HI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,YCwHmB;EDvHnB,YCuH8B;EDtH9B,gBAAA;EACA,sBAAA;EACA,sBAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;ECkHA,kBAAA;EACA,gBAAA;AAgEJ;ADlLI;EC+GJ;ID9GQ,WAAA;ECqLN;AACF;AApEI;EACI,SAAA;EACA,iBAAA;EACA,6CAAA;AAsER;AAnEI;EACI,kBAAA;EDpPJ,aAAA;EACA,eAAA;EACA,mBAHY;EAIZ,uBAJqB;EAKrB,mBALiC;EAMjC,QAN6C;ACgUjD;AAzEQ;EACI,UAAA;EACA,aAAA;EACA,kBAAA;AA2EZ;AAzEQ;EACI,UAAA;AA2EZ;AAxEI;EACI,WAAA;AA0ER;AAvEI;EACI,gBAAA;AAyER;AAxEQ;;EAEI,kBAAA;AA0EZ;AAxEY;;EACI,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;AA2EhB;AAxEY;;EACI,oCAAA;AA2EhB;AAxEY;;;;EAEI,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AA4EhB;AA3EgB;;;;EACI,WAAA;AAgFpB;AA/EoB;;;;EACI,yBDjVZ;ECkVY,cAAA;EACA,gBAAA;AAoFxB;AAnFwB;;;;EACI,kBAAA;AAwF5B;AAlFoB;;;;EACI,gCAAA;AAuFxB;AArFwB;;;;EACI,6BAAA;AA0F5B;AAxFwB;;;;EACI,gCAAA;AA6F5B;AA1FwB;;;;EACI,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AA+F5B;AAvFI;ED/TA,aAAA;EACA,eAAA;EACA,mBAHY;EAIZ,8BC6TsB;ED5TtB,mBALiC;EAMjC,QAN6C;ECkUzC,WAAA;EACA,sBAAA;EACA,aAAA;AA8FR;AA7FQ;EACI,UAAA;AA+FZ","sourcesContent":["$nitroDark: #2c53a0;\n$nitroLight: #64c4e0;\n$background: #e4ffff;\n$fontColor: #4d4d4d;\n$error: #bb0000;\n$warning: #f29422;\n\n/*media breaks*/\n$mobile: 600px;\n$tablet: 768px;\n$laptop: 900px;\n$tabletMin: 691px;\n$tabletMax: 850px;\n$landsTabletMin: 851px;\n$landsTabletMax: 1300px;\n$smallLaptopMin: 1301px;\n$smallLaptopMax: 1439px;\n$smallScreen: 1440px;\n$regularScreen: 1900px;\n$bigScreen: 1920px;\n$fourK: 2000px;\n\n@font-face {\n    font-family: \"digital-clock-font\";\n    src: url(\"./Fuel/font/digital-7.ttf\");\n}\n\n@mixin shadow {\n    box-shadow: 4px 2px 8px rgba(0, 0, 0, 0.2);\n}\n\n@mixin card {\n    background-color: #fff;\n    @include shadow;\n    border-radius: 1rem;\n}\n\n@mixin alertCard {\n    box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px,\n        rgba(0, 0, 0, 0.23) 0px 6px 6px;\n    background-color: #fff;\n    border-radius: 0.5rem;\n}\n\n@mixin eposCard {\n    background-color: #fff;\n    box-shadow: rgba(0, 0, 0, 0.09) 0px 2px 1px, rgba(0, 0, 0, 0.09) 0px 4px 2px,\n        rgba(0, 0, 0, 0.09) 0px 8px 4px, rgba(0, 0, 0, 0.09) 0px 16px 8px,\n        rgba(0, 0, 0, 0.09) 0px 32px 16px;\n}\n\n@mixin flex($d: row, $j: center, $a: center, $g: 1vw) {\n    display: flex;\n    flex-wrap: wrap;\n    flex-direction: $d;\n    justify-content: $j;\n    align-items: $a;\n    gap: $g;\n}\n\n@mixin columnStack {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin columnStart {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n}\n@mixin columnAlignStart {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n}\n\n@mixin columnAlignStartTop {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n}\n\n@mixin rowEven {\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n    flex-wrap: wrap;\n}\n\n@mixin rowEvenStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-evenly;\n}\n@mixin rowEvenStartCenter {\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n}\n\n@mixin rowStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: center;\n}\n@mixin rowBetween {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n@mixin rowBetweenStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n}\n\n@mixin rowCenter {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin rowStart {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n@mixin table {\n    table-layout: fixed;\n    background-color: #fff;\n    border-collapse: collapse;\n    color: $fontColor;\n    thead {\n        border-bottom: 1px solid $fontColor;\n        text-align: center;\n    }\n    tbody {\n        text-align: center;\n        tr {\n            border-bottom: 1px solid $fontColor;\n            &:nth-child(odd) {\n                background-color: #f2f2f2;\n            }\n            input {\n                width: 20%;\n                margin: 0 auto;\n                text-align: center;\n            }\n        }\n    }\n}\n\n//MODAL STYLING\n\n@mixin modal($h: auto, $w: auto) {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: $w;\n    height: $h;\n    max-height: 50vh;\n    background-color: #fff;\n    border: 2px solid #000;\n    box-shadow: 24;\n    padding: 10px;\n    overflow-y: auto;\n    @media (max-width: 600px) {\n        width: 95vw;\n    }\n}\n","@import \"../../variables.scss\";\n\n.orderContent {\n    display: flex;\n    flex-direction: column;\n    color: $fontColor;\n    width: 100%;\n    min-height: 72vh;\n    .head {\n        display: flex;\n        justify-content: space-around;\n        flex-wrap: wrap;\n        width: 80%;\n        margin: 0 auto;\n        h4 {\n            padding: 1%;\n            margin: 0.5vh auto;\n            text-align: center;\n            color: $fontColor;\n            border-radius: 5px;\n            background-color: #fff;\n            box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\n            width: 310px;\n        }\n    }\n    .boxes {\n        @include columnStart;\n        min-height: 75vh;\n        input {\n            margin: 2% auto;\n        }\n    }\n    .quantities {\n        display: flex;\n        justify-content: space-evenly;\n        padding: 1%;\n        width: 40%;\n        margin: auto;\n        margin-bottom: 1%;\n        align-items: center;\n        .qty {\n            width: 48%;\n            text-align: center;\n            background-color: #fff;\n            font-weight: bold;\n            display: flex;\n            justify-content: space-evenly;\n            box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\n            border-radius: 1rem;\n            input {\n                border: none;\n                background-color: #fff;\n                width: 80%;\n                color: #4d4d4d;\n            }\n        }\n    }\n    .row {\n        display: flex;\n        justify-content: space-evenly;\n        width: 50%;\n        margin: auto;\n        p {\n            text-align: center;\n            padding: 5%;\n            border: 1px solid #c2c2c2;\n            border-radius: 50%;\n            background: #fff;\n        }\n    }\n    #invoice,\n    .additional-items-table {\n        @include table;\n        width: 80%;\n        margin: auto;\n    }\n    .additional-items-table {\n        margin: 2vh auto;\n    }\n    #section {\n        width: 75%;\n        margin: auto;\n        margin-top: 0;\n        background-color: #fff;\n        border-collapse: collapse;\n        th {\n            background-color: $nitroLight;\n        }\n        td {\n            border-bottom: 1px solid $fontColor;\n        }\n        td:nth-child(2) {\n            text-align: center;\n        }\n        td:nth-child(3) {\n            text-align: center;\n            input {\n                text-align: center;\n                width: 30%;\n                border: 1px solid $fontColor;\n                border-radius: 0.3rem;\n                height: 2rem;\n            }\n        }\n    }\n    .staffName,\n    .note_section {\n        margin: 1.5vh auto;\n        width: 40%;\n        min-width: 310px;\n        border-radius: 5px;\n        height: 4.5vh;\n        font-size: 1.1rem;\n    }\n\n    .note_section {\n        height: 12vh;\n        padding-top: 5px;\n        max-width: 40%;\n        max-height: 12vh;\n    }\n    .final_submit_btn {\n        width: 40%;\n        min-width: 310px;\n        margin: 1.5vh auto;\n    }\n\n    .checkInput {\n        width: 30%;\n        border: none;\n        border-radius: 0.3rem;\n        height: 2rem;\n    }\n    .pack {\n        font-size: 1.4rem;\n    }\n    .loadingSection {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n    }\n    input[type=\"file\"] {\n        align-self: center;\n    }\n    .image__div {\n        img {\n            align-self: center;\n            margin-left: 30%;\n        }\n    }\n    textarea {\n        width: 30%;\n        align-self: center;\n        margin: 1% auto;\n    }\n}\n\n@media (max-width: $mobile) {\n    .orderContent {\n        .quantities {\n            width: 80%;\n            min-height: 12vh;\n            .qty {\n                font-size: 0.9rem;\n            }\n        }\n        .row {\n            width: 80%;\n        }\n\n        #invoice,\n        .additional-items-table {\n            display: block;\n            .table_header {\n                display: none;\n            }\n\n            thead {\n                height: 0;\n                display: block;\n                tr {\n                    position: absolute;\n                    top: -9999px;\n                    left: -9999px;\n                    th {\n                        display: block;\n                    }\n                }\n            }\n\n            tbody {\n                display: block;\n                tr {\n                    display: block;\n                    margin-bottom: 0.5vh;\n                    border: 1px solid #ccc;\n                    td {\n                        display: block;\n                        border: none;\n                        border-bottom: 1px solid #eee;\n                        position: relative;\n                        padding-left: 50%;\n                    }\n\n                    td:before {\n                        position: absolute;\n                        top: 2px;\n                        left: 6px;\n                        width: 45%;\n                        padding-right: 10px;\n                        white-space: nowrap;\n                        font-weight: 700;\n                        text-align: left;\n                    }\n                }\n            }\n            td:nth-of-type(1):before {\n                content: \"Product\";\n            }\n            td:nth-of-type(2):before {\n                content: \"Ordered\";\n            }\n            td:nth-of-type(3):before {\n                content: \"Received\";\n            }\n            td:nth-of-type(4):before {\n                content: \"Current Stock\";\n            }\n        }\n\n        #invoice,\n        .additional-items-table,\n        #section {\n            width: 80%;\n            td:nth-child(3) {\n                input {\n                    text-align: center;\n                    width: 50%;\n                    border: 1px solid $fontColor;\n                    border-radius: 0.3rem;\n                    height: 2rem;\n                }\n            }\n        }\n\n        .pack {\n            font-size: 1.1rem;\n        }\n        .image__div {\n            img {\n                width: 60%;\n                margin-left: 20%;\n            }\n        }\n        textarea {\n            width: 50%;\n        }\n    }\n}\n@media (min-width: 601px) and (max-width: $laptop) {\n    .orderContent {\n        .image__div {\n            img {\n                width: 60%;\n                margin-left: 20%;\n            }\n        }\n    }\n}\n\n.discrepancy_modal {\n    @include columnStart;\n    .discrepancy_table {\n        @include table;\n        width: 90%;\n        margin: 0 auto;\n    }\n    .discrep_modal_row {\n        width: 90%;\n        margin: 2% auto;\n        @include rowEven;\n    }\n}\n\n.add-extra-items-modal {\n    @include modal($w: 600px, $h: 60vh);\n    position: relative;\n    overflow-y: auto;\n    h1 {\n        margin: 0;\n        font-size: 1.5rem;\n        box-shadow: 0 4px 2px -2px rgb(124, 124, 124);\n    }\n\n    .search-items {\n        margin: 0.5vh auto;\n        @include flex();\n        input {\n            width: 70%;\n            height: 4.2vh;\n            border-radius: 5px;\n        }\n        button {\n            width: 10%;\n        }\n    }\n    .alert-section {\n        height: 7vh;\n    }\n\n    .product-tables {\n        min-height: 22vh;\n        .additional-items-table-container,\n        .multiple-items-table-container {\n            margin: 0.5vh auto;\n\n            p {\n                text-align: center;\n                color: #000;\n                font-weight: 500;\n                font-size: 1.2rem;\n            }\n\n            .additional-items-table {\n                background-color: rgb(160, 255, 160);\n            }\n\n            .additional-items-table,\n            .multiple-items-table {\n                width: 100%;\n                font-size: 0.9em;\n                font-family: sans-serif;\n                table-layout: fixed;\n                thead {\n                    height: 4vh;\n                    tr {\n                        background-color: $nitroDark;\n                        color: #ffffff;\n                        text-align: left;\n                        th {\n                            text-align: center;\n                        }\n                    }\n                }\n\n                tbody {\n                    tr {\n                        border-bottom: 1px solid #dddddd;\n\n                        &:first-of-type {\n                            border-top: 2px solid $nitroDark;\n                        }\n                        &:last-of-type {\n                            border-bottom: 2px solid $nitroDark;\n                        }\n\n                        td {\n                            text-align: center;\n                            padding: 12px 15px;\n                            word-wrap: break-word;\n                            color: black;\n                            font-size: 1rem;\n                            font-weight: 500;\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    .btn-section {\n        @include flex($j: space-between);\n        margin: 2vh;\n        background-color: #fff;\n        z-index: 9000;\n        button {\n            width: 45%;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
